import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InactivityScreenState {
    inactivityReason: string;
    showLoginButton: boolean;
}

const initialState: InactivityScreenState = {
    inactivityReason: '',
    showLoginButton: true,
};

const inactivityScreenSlice = createSlice({
    name: 'locked',
    initialState,
    reducers: {
        showLockedScreen: (state, action: PayloadAction<InactivityScreenState>) => {
            state.inactivityReason = action.payload.inactivityReason;
            state.showLoginButton = action.payload.showLoginButton;
        },
    },
});

export const { showLockedScreen } = inactivityScreenSlice.actions;
export default inactivityScreenSlice.reducer;
